import { render, staticRenderFns } from "./CompositionStep3.vue?vue&type=template&id=0ef7a943&"
import script from "./CompositionStep3.vue?vue&type=script&lang=js&"
export * from "./CompositionStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports